export function getBaseCheckboxStyle(theme, checked) {
    return {
        checkbox: {
            background: checked ? theme.customSemanticColors.accentFillDefault : theme.customSemanticColors.controlAltFillSecondary,
            // Specify due to bug where FluentUI Checkbox doesn't use semanticColors.smallInputBorder as it should, and because of the way
            // checked styles are applied to FluentUI Checkbox, this then also requires us to properly override the borderColor when checked.
            borderColor: checked ? theme.customSemanticColors.accentFillDefault : theme.customSemanticColors.controlStrongStrokeDefault,
            borderRadius: "3px",
            marginRight: "8px",
        },
        checkmark: {
            color: checked ? theme.customSemanticColors.textOnAccentPrimary : "transparent",
        },
        root: {
            /* eslint-disable sort-keys */
            ":hover .ms-Checkbox-checkbox": {
                background: checked ? undefined : theme.customSemanticColors.controlAltFillTertiary,
                // Specify due to this FluentUI Checkboc re-using semanticColor.inputBorderHovered rather than a separate color.
                // We need semanticColors.inputBorderHovered to remain transparent for other controls that use elevation instead
                // of a stroke. and because of the way checked styles are applied to FluentUI Checkbox, this then also requires us
                // to properly override the borderColor when checked.
                borderColor: checked ? theme.customSemanticColors.accentFillDefault : theme.customSemanticColors.controlStrongStrokeDefault,
            },
            ":active .ms-Checkbox-checkbox": {
                background: checked ? undefined : theme.customSemanticColors.controlAltFillQuarternary,
                // Specify due to this FluentUI Checkboc re-using semanticColor.inputBorderHovered rather than a separate color.
                // We need semanticColors.inputBorderHovered to remain transparent for other controls that use elevation instead
                // of a stroke. and because of the way checked styles are applied to FluentUI Checkbox, this then also requires us
                // to properly override the borderColor when checked.
                borderColor: checked
                    ? theme.customSemanticColors.accentFillTertiary
                    : theme.customSemanticColors.controlStrongStrokeDisabled,
            },
            ":hover .ms-Checkbox-checkmark": {
                color: checked ? theme.customSemanticColors.textOnAccentPrimary : "transparent",
            },
            ":active .ms-Checkbox-checkmark": {
                color: checked ? theme.customSemanticColors.textOnAccentSecondary : "transparent",
            },
            /* eslint-enable sort-keys */
        },
        text: Object.assign(Object.assign({ marginLeft: "0px", verticalAlign: "center" }, theme.fonts.small), { lineHeight: "20px" }),
    };
}
